import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import Chip from '@mui/material/Chip';

import { transactionsUtils, transactionsTypes } from 'companion-app-components/flux/transactions';

import { isC2RTransaction } from 'data/transactions/utils';
import RegCategoryField from './RegCategoryField';
import { RegListItem, styles } from '../styles';
import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface CategoryFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  wrapClass: string;
  editClass: string; 
  hoverClass: string;
  bankPendingClass: string;
  currEditFieldName: string;
  wrapperId: string;
  longCats: boolean;
  wrapText: string;
  showSplitWindow: boolean;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const CategoryField: FC<CategoryFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  editable,
  SHOW_ALL,
  txn,
  wrapClass,
  editClass, 
  hoverClass,
  bankPendingClass,
  currEditFieldName,
  wrapperId,
  longCats,
  wrapText,
  showSplitWindow,
  focusField,
}) => {

  const { classes } = useStyles();
  const c2RTxnClass = isC2RTransaction(txn) ? classes.txnInC2RText : '';
  return (
    <RegListItem
      {...attributes}
      className={classNames(
        classes.regItem,
        'flex2',
        wrapClass,
        editClass, 
        hoverClass,
        bankPendingClass,
        c2RTxnClass,
        (transactionsUtils.isSplitTxn(txn) && editable) ? classes.withClearSplits : null,
      )}
      onClick={(!txn.split && forceStatic) ? null : () =>
        callbacks.regFieldClick?.('category', txn)}
    >
      {SHOW_ALL &&
        <RegCategoryField
          txn={txn}
          editable={editable && currEditFieldName === 'category'}
          // @ts-expect-error: The expected type comes from property 'onChange' which is declared here on type 'IntrinsicAttributes & AmountFieldProps'
          onChange={callbacks.handleChange}
          forceStatic={forceStatic}
          longCats={longCats}
          // @ts-expect-error: Type 'string' is not assignable to type 'boolean'.
          wrapText={wrapText}
          showSplitWindow={showSplitWindow}
          context={wrapperId}
          inputRef={editable && !forceStatic && currEditFieldName === 'category' ?
            (input) => {
              focusField.current = input; // eslint-disable-line
            } : null}
        />}
      {transactionsUtils.isSplitTxn(txn) && editable && 
        <Chip 
          label="Clear Splits" 
          size="small" 
          onClick={(e) => {
            e.stopPropagation();
            callbacks.regFieldClick?.('clearSplits', txn);
          }}
          className={classes.clearSplits}
        />}
    </RegListItem>
  );
};

export default CategoryField;
